import './Credit.css';

import { Button, Modal } from 'react-bootstrap';
import React, { useContext, useEffect, useState, forwardRef, useImperativeHandle } from "react";

import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';

const Credit = forwardRef(({ seriall }, ref) => {
    //const mounth12 = 759000;//399000; 
    //const mounth6 = 455000;//210000;
    const [creditePrice, setCreditPrice] = useState(
        {
            credit6Enabled: false,
            credit6Price: 455000,

            credit12Enabled: true,
            credit12Price: 759000
        }
    )

    const [isLoading, setIsLoading] = useState(false);
    const [isPosting, setIsPosting] = useState(false);
    useEffect(() => {
        loadData()
        CreditPrice();
    }, []);

    const [listMaster, setListMaster] = useState([]);
    const [list, setList] = useState([]);

    const rialToToman = (value) => {
        const n = Number(value);
        if (isNaN(n) || n <= 0) return 0;
        return Math.floor(n / 10);
    };

    const [isLoadingCreditPrice, setIsLoadingCreditPrice] = useState(false)
    const CreditPrice = async () => {
        setIsLoadingCreditPrice(true);
        await noronServices.GetCurrentCreditPrice()
            .then(({ data }) => {
                setIsLoadingCreditPrice(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                const p = data.payload || {};

                setCreditPrice({
                    credit6Enabled: !!p.credit6Enabled,
                    credit6Price: rialToToman(p.credit6Price),

                    credit12Enabled: !!p.credit12Enabled,
                    credit12Price: rialToToman(p.credit12Price),
                });
            })
            .catch(err => {
                setIsLoadingCreditPrice(false);
            });
    }

    const loadData = async () => {
        setIsLoading(true);
        const service = seriall ? noronServices.GetCreditUser : noronServices.GetCredit;
        await service(seriall)
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                let temp = { ...data.payload };
                if (data.payload.length == 1) {
                    temp[0].mounth = 12;
                }
                setList(data.payload);
                setListMaster(data.payload);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }

    const [sum, setSum] = useState(0);
    useEffect(() => {
        setSum(list.reduce((sum, x) => sum + (x.mounth == 12 ? creditePrice.credit12Price : x.mounth == 6 ? creditePrice.credit6Price : 0), 0))
    }, [list, creditePrice]);


    const [search, setSearch] = useState("");
    useEffect(() => {
        if (search == "")
            setList([...listMaster]);
        const temp = [...listMaster];
        const temp2 = temp.filter(x => x.ime.includes(search) || x.name.includes(search));
        setList([...temp2]);
    }, [search]);
    const [discount, setDiscount] = useState("")

    const addCredit = async (e) => {
        e.preventDefault();
        const listForm = list.filter(x => "mounth" in x && x.mounth > 0);
        if (listForm.length <= 0) {
            toast.error(' دستگاه/خودرو مشخص نشده است', { theme: "colored" });
            return;
        } 
        
        setIsPosting(true);
        const service = seriall ? noronServices.AddCreditUser : noronServices.AddCredit;
        await service(listForm.map(x =>
        (
            {
                id: x.id,
                mounth: x.mounth,
                Plane: "advance"
            }
        )
        ), seriall, discount)
            .then(({ data }) => {
                setIsPosting(false);
                //toast.dark('داده رسید');
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                toast.dark('لطفا تا انتقال به درگاه بانک شکیبا باشید');
                window.location = data.payload;
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    useImperativeHandle(ref, () => ({ addCredit, }));
    return (
        <>

            <div className="container">
                {(isLoading || isLoadingCreditPrice) &&
                    <div className="spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>}
                {list.length == 1 && (
                    <>
                        <div className='row mt-3'>
                            <div className='col'>
                                <div className={`alert ${list[0].dayActive > 0 ? "alert-success" : "alert-danger"}`}>
                                    {list[0].dayActive > 0 ? (<> اعتبار دستگاه شما {list[0].dayActive} روز می باشد </>) :
                                        <>دستگاه شما فاقد اعتبار می باشد</>}
                                </div>
                            </div>
                        </div>
                        {creditePrice.credit12Enabled &&
                            <div className='d-flex flex-row mt-3'>
                                <div className="form-check-inline">
                                    <input
                                        type="radio"
                                        name="modeAlarm"
                                        value="12"
                                        checked={list[0].mounth == 12}
                                        onChange={e => {
                                            const temp = [...list];
                                            const temp2 = temp.map(x => { x.mounth = e.target.value; return x; });
                                            setList([...temp2]);
                                        }}
                                        className=" form-check-input" />
                                    <span className="ms-2 my-0 fw-normal">
                                        پنل <span className="mx-2 badge rounded-pill bg-success">یکساله</span>
                                        هزینه هر خودرو : {`${creditePrice.credit12Price.toLocaleString()}`}
                                        <small className="text-muted fw-light">تومان</small>
                                        + 10 درصد مالیات بر ارزش افزوده
                                    </span>
                                </div>
                            </div>
                        }
                        {creditePrice.credit6Enabled &&
                            <div className='d-flex flex-row mt-3'>
                                <div className="form-check-inline">
                                    <input
                                        type="radio"
                                        name="modeAlarm"
                                        value="6"
                                        checked={list[0].mounth == 6}
                                        onChange={e => {
                                            const temp = [...list];
                                            const temp2 = temp.map(x => { x.mounth = e.target.value; return x; });
                                            setList([...temp2]);
                                        }}
                                        className=" form-check-input" />
                                    <span className="ms-2 my-0 fw-normal">
                                        پنل <span className="mx-2 badge rounded-pill bg-success">6 ماهه</span>
                                        هزینه هر خودرو : {`${creditePrice.credit6Price.toLocaleString()}`}
                                        <small className="text-muted fw-light">تومان</small>
                                        + 10 درصد مالیات بر ارزش افزوده
                                    </span>
                                </div>
                            </div>
                        }

                    </>
                )}
                {list.length > 1 &&
                    <div className="table-responsive">
                        <table className="table table-striped table-striped-columns table-bordered  ">
                            <thead>
                                <tr>
                                    <td colSpan={4}>
                                        {creditePrice.credit12Enabled &&
                                            <div className='d-flex flex-row mt-3'>
                                                <span className="my-0 fw-normal">
                                                    پنل <span className="mx-2 badge rounded-pill bg-success">یکساله</span>
                                                    هزینه هر خودرو : {`${creditePrice.credit12Price.toLocaleString()}`}
                                                    <small className="text-muted fw-light">تومان</small>
                                                    + 10 درصد مالیات بر ارزش افزوده
                                                </span>
                                            </div>
                                        }
                                        {creditePrice.credit6Enabled &&
                                            <div className='d-flex flex-row mt-3'>
                                                <span className="my-0 fw-normal">
                                                    پنل <span className="mx-2 badge rounded-pill bg-success">6 ماهه</span>
                                                    هزینه هر خودرو : {`${creditePrice.credit6Price.toLocaleString()}`}
                                                    <small className="text-muted fw-light">تومان</small>
                                                    + 10 درصد مالیات بر ارزش افزوده
                                                </span>
                                            </div>
                                        }
                                    </td>
                                </tr>

                                <tr className='mt-3'>
                                    <td colSpan={4} className=''>
                                        <div className='row'>
                                            <div className='col  d-flex flex-row justify-content-center'>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={search}
                                                    placeholder='جستجو'
                                                    onChange={e => setSearch(e.target.value)} />
                                            </div>

                                        </div>
                                    </td>
                                </tr>

                                <tr className='mt-3'>
                                    <td>تمدید همه دستگاه ها
                                        <select
                                            className='form-select'
                                            onChange={e => {
                                                const temp = [...list];
                                                const temp2 = temp.map(x => { x.mounth = e.target.value; return x; });
                                                setList([...temp2]);
                                            }}
                                        >
                                            <option value="0">انتخاب کنید</option>
                                            {creditePrice.credit12Enabled && <option value="12">یکساله</option>}
                                            {creditePrice.credit6Enabled && <option value="6">6 ماهه</option>}
                                        </select>
                                    </td>
                                </tr>

                            </thead>
                            <tbody>
                                {list.map((x, i) => (
                                    <tr className={`${x.dayActive <= 0 ? " rowNoActive" : ""}`} key={i}>
                                        <td>
                                            <div className="row align-items-center p-3 mb-3 border rounded-3 shadow-sm ">

                                                <div className="col">
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="d-flex align-items-center">
                                                            <span className="text-muted fw-light me-2" style={{ fontSize: '0.9rem' }}>دستگاه:</span>
                                                            <span className="fw-bold text-dark">{x.name}</span>
                                                        </div>
                                                        <div className="text-secondary small">
                                                            <i className="bi bi-cpu me-1"></i> {/* اگر از bootstrap-icons استفاده می‌کنید */}
                                                            <span className="font-monospace bg-light px-2 rounded">{x.ime}</span>
                                                        </div>

                                                        <div className="mt-2 d-flex align-items-center">
                                                            <span className="badge bg-info-subtle text-info-emphasis border border-info-subtle rounded-pill px-3 text-danger">
                                                                <span className="me-1">اعتبار:</span>
                                                                <span className="fw-bold me-1">{x.dayActive}</span>
                                                                <span>روز</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-auto">
                                                    <div className="input-group">
                                                        <label className="input-group-text bg-light text-muted" style={{ fontSize: '0.8rem' }}>تمدید</label>
                                                        <select
                                                            className="form-select border-start-0 shadow-none"
                                                            style={{ minWidth: '130px', cursor: 'pointer' }}
                                                            onChange={e => {
                                                                const temp = [...list];
                                                                temp[i].mounth = e.target.value;
                                                                setList([...temp]);
                                                            }}
                                                            value={x.mounth}
                                                        >
                                                            <option value="0">انتخاب کنید...</option>
                                                            {creditePrice.credit12Enabled && <option value="12">یکساله</option>}
                                                            {creditePrice.credit6Enabled && <option value="6">۶ ماهه</option>}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>



                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                }

                <div className='row mt-3 sticky-bottom bg-white'>
                    <div className='col-auto'>
                        <input
                            type="text"
                            className='form-control'
                            name="discount"
                            value={discount}
                            onChange={e => { setDiscount(e.target.value) }}
                            placeholder='کد تخفیف'
                        />
                    </div>
                    <div className='col d-flex align-items-center'>
                        <span className="mx-2 ">مبلغ : </span>{Math.round(sum + sum * 0.10).toLocaleString()}
                        <small className="text-muted fw-light mx-2">تومان</small>
                    </div>
                    <Link className='text-danger mt-1 text-decoration-underline' to="/videoupload">دریافت کد تخفیف</Link>
                </div>

            </div >

        </>

    );

}
);

export default Credit;
